'use client';

import { Button } from '@/src/components/ui/button';
import { useRouter } from '@/src/i18n/navigation';
import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEvents } from '@/src/lib/amplitude/events';
import useUserStore from '@/src/lib/state-stores/userStore';
import { UserIcon } from 'lucide-react';
import { Session } from 'next-auth';
import { signIn, signOut } from 'next-auth/react';
import Image from 'next/image';

type Props = {
  login: string;
  signUp: string;
  session: Session;
};

async function keycloakSessionLogOut() {
  try {
    await fetch(`/api/auth/logout`, { method: 'GET' });
  } catch (err) {
    // console.error(err);
  }
}

const AuthButton = ({ login, signUp, session }: Props) => {
  const { clearUser } = useUserStore();
  const router = useRouter();
  return session?.user ? (
    <div className="w-full">
      <Button
        variant={'outline'}
        rounded={'full'}
        color="error"
        className="flex w-full cursor-pointer items-center gap-2 border-red-400"
        onClick={() => {
          keycloakSessionLogOut().then(() => signOut({ callbackUrl: window.location.href }));
          router.push('/');
          trackEvent(AmplitudeEvents.signed_out);
          clearUser();
        }}
      >
        <Image
          src={'/assets/sign-out.svg'}
          alt="sign-out"
          width={'24'}
          height={'24'}
          className="pointer-events-none"
        />
        <h2 className="pointer-events-none text-center text-lg font-normal text-[#D62550]">
          {signUp}
        </h2>
      </Button>
    </div>
  ) : (
    <Button
      rounded={'full'}
      className="flex items-center"
      onClick={() =>
        signIn('keycloak', {
          redirect: true,
        })
      }
    >
      <p>{login}</p>
      <UserIcon />
    </Button>
  );
};

export default AuthButton;
